export default {
  brandColor1: '#000000',
  complimentaryColor1: '#f0ede5',
  brandColor2: '#111F89',
  complimentaryColor2: '#f0ede5',
};
